import React from 'react';
import PropTypes from 'prop-types';

function FooterActions({ onCredits, onRefer }) {
  return (
    <div className="footer-actions">
      <button className="action-btn gems-btn" onClick={onCredits} type="button">
        <span className="largedimond" aria-hidden="true">💎</span>
        <span>Credits</span>
      </button>

      <button className="action-btn refer-btn" onClick={onRefer} type="button">
        <span aria-hidden="true">🎁</span>
        <span>Refer</span>
      </button>
    </div>
  );
}

FooterActions.propTypes = {
  onCredits: PropTypes.func.isRequired,
  onRefer: PropTypes.func.isRequired,
};

export default FooterActions;